exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-id-small {\n  font-size: 12px;\n  color: hsla(0, 0%, 50%, 1);\n}\n@media (max-width: 992px) {\n.long-description {\n    border-radius: 0px !important;\n    border: none !important;\n    background: none !important;\n}\n.box {\n    gap: 0px;\n}\n.box ul{\n    padding: 0 0 0 1rem;\n}\n}\n@media (min-width: 992px) {\n.long-description {\n    gap: 0px;\n}\n.box ul{\n    padding: 0 0 0 1rem;\n}\n}\n", ""]);

// exports
